import createStyle from "@josephmark/createstyle"

export const CircleSkele = createStyle("div", "h-5 w-5 rounded-full bg-black/5 dark:bg-white/10")
export const LineSkele = createStyle("div", "h-2 min-w-5 rounded-full bg-black/5 dark:bg-white/10")
